<template>
  <div :id="`artwork_dropzone-${dz_index}`" class="artwork-dropzone row align-items-center" :class="slim && 'slim'">
    <div class="d-none preview dropzone-previews" />
    <span class="icon">+</span>
  </div>
</template>

<script>

if (window.Dropzone) {
  window.Dropzone.autoDiscover = false;
}

let uploader_dz_index = 0;

export default {
  name: "Drop",
  props: {
    dropzoneConfig: {
      type: Object,
      required: true,
    },
    slim: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    config: {
      title: "Upload",
      clickable: ".artwork-uploader-dropzone-trigger",
      previewsContainer: ".preview",
      params: {},
      parallelUploads: 20,
      maxFiles: 20,
      acceptedFiles: "image/jpg,image/jpeg,image/pjpeg,image/png",
      createImageThumbnails: true,
      method: "POST",
      dictDefaultMessage: "Click or Drag Image to Upload",
      thumbnailWidth: 80,
      thumbnailHeight: 80,
      uploadMultiple: true,
      maxFilesize: 5, // 5MB
      timeout: 300000, // 5min
    },
    dz_index: null,
  }),
  beforeMount() {
    this.dz_index = uploader_dz_index++;
  },
  mounted() {
    const config = this.getConfig();
    const my_dropzone = new window.Dropzone(`#artwork_dropzone-${this.dz_index}`, {
      headers: {
        "X-CSRF-TOKEN": document.head.querySelector(
          'meta[name="csrf-token"]',
        ).content,
      },
      url: config.url,
      parallelUploads: config.parallelUploads,
      maxFiles: config.maxFiles,
      acceptedFiles: config.acceptedFiles,
      createImageThumbnails: config.createImageThumbnails,
      thumbnailWidth: config.thumbnailWidth,
      thumbnailHeight: config.thumbnailHeight,
      uploadMultiple: config.uploadMultiple,
      dictDefaultMessage: config.dictDefaultMessage,
      maxFilesize: config.maxFilesize,
      previewsContainer: ".preview",
      timeout: config.timeout,
      successmultiple(files, response) {
        let error_count = 0;

        if (response.success) {
          for (const file of files) {
            if (file.size === 0) {
              error_count++;
              toastr.error('Upload error: file size is 0');
            }
          }

          error_count > 0
            ? toastr.warning("One or more files failed to upload")
            : toastr.success("File(s) uploaded succesfully");

          if (response.data) {
            EventBus.$emit("upload-success", response.data);
          } else {
            EventBus.$emit("upload-success");
          }

          my_dropzone.removeAllFiles();
        } else {
          toastr.error(response.error.message);
          my_dropzone.removeAllFiles();
        }
      },
      maxfilesexceeded() {
        toastr.error(`You can only upload ${config.maxFiles} at a time`);
      },
      error: (file, response) => {
        if (response && response.error && response.error.message) {
          toastr.error(response.error.message);
        } else if (typeof response === `string`) {
          toastr.error(`Upload error: ${response}`);
        } else {
          toastr.error("Something unexpected went wrong, please contact SharpStream Support");
        }

        my_dropzone.removeAllFiles();
      },
    });
  },
  methods: {
    getConfig() {
      // Merge config passed to with default config
      const default_config = this.config;
      const config = this.dropzoneConfig;
      for (const attribute in config) {
        default_config[attribute] = config[attribute];
      }
      return default_config;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "~AssetsSass/_variables" as *;

.artwork-dropzone {
  height: 250px;
  width: 250px;
  border: 2px dashed map.get($ss, 'primary');
  border-radius: 12px;
  color: map.get($ss, 'primary');
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4em;

  &.slim {
    height: 150px;
    width: 150px;
  }

  .icon {
    pointer-events: none;
  }

  .dz-default {
    font-size: 80px;
    height: 100px;
    margin-top: 5px;
  }

  .dz-message {
    font-size: 80px;
    height: 100px;
    margin-top: 5px;
  }

  .dz-preview {
    display: none;
  }
}
</style>
